import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavDropdown } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars';
import { Badge } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { updateNotificationIsRead , fetchNotifications } from '../redux/actions';
import {
    applicationSelector,
    awardSelector,
    chapterSelector,
    notificationSelector,
    rankSelector,
    userSelector
} from "../redux/selectors";
import {
    NotificationAward,
    NotificationApplication,
    NotificationChapter,
    NotificationMentionComment,
    NotificationMentionForum,
    NotificationPromotion,
    NotificationDemotion,
    NotificationEvent,
    NotificationKicked,
    NotificationQuote,
    NotificationScreenshot,
    NotificationDKPItem,
    NotificationDKPResourceContrib
} from './NotificationTypes';
import {toArray} from "../common/util";




class Notifications extends Component {
    handleClick(notification_list) {
        return () => {
            for (let i = 0; i < notification_list.length; i++) {
                if (notification_list[i].isRead === false) {
                    this.props.readNotification(notification_list[i].id);
                }
            }
        }
    };
    componentDidMount() {
        this.props.getNotifications();
    }
    componentSwitch = (item) => {
        switch (item.type) {
            case "username_mention_comment":
                return <NotificationMentionComment notification={item} />;
            case "username_mention_forum":
                return <NotificationMentionForum notification={item} />;
            case "application":
                return <NotificationApplication notification={item} users={this.props.users} applications={this.props.applications} chapters={this.props.chapters} />;
            case "award":
                return <NotificationAward notification={item} awards={this.props.awards}/>;
            case "promotion":
                return <NotificationPromotion notification={item} ranks={this.props.ranks}/>;
            case "demotion":
                return <NotificationDemotion notification={item} ranks={this.props.ranks}/>;
            case "event":
                return  <NotificationEvent notification={item} />;
            case "kicked":
                return  <NotificationKicked notification={item} />;
            case "quote":
                return <NotificationQuote notification={item} />;
            case "screenshot":
                return  <NotificationScreenshot notification={item} />;
            case "chapter":
                return <NotificationChapter notification={item} chapters={this.props.chapters} />;
            case "dkp_item":
                return <NotificationDKPItem notification={item} />;
            case "dkp_resourcecontrib":
                return <NotificationDKPResourceContrib notification={item} />;
            default:
                return null
        }
    };

    render() {
        if (this.props.isAuthenticated) {
            let unread_notifications = toArray(this.props.notifications.data).filter(notification => notification.isRead === false);
            let badgeCount = unread_notifications.length;
            return (
                <NavDropdown
                    eventKey={2}
                    id="notifications-nav-dropdown"
                    noCaret
                    title={
                        (badgeCount > 0) ? (
                            <Badge badgeContent={badgeCount} color="primary">
                                <FontAwesomeIcon size="sm" icon={faBell} fixedWidth />
                            </Badge>
                        ) : (
                            <FontAwesomeIcon size="sm" icon={faBell} fixedWidth />
                        )
                    }
                >
                    <li>
                        <h3>Notifications</h3>
                    </li>
                    <li>
                        <Scrollbars style={{ height:'300px' }} autoHide >
                            {toArray(this.props.notifications.data)
                                .sort((a, b) => (new Date(b.created).getTime() - new Date(a.created).getTime()))
                                .map(notification =>
                                <div
                                    style={(notification.isRead) ? ({opacity: 0.7}) : ({opacity: 1})}
                                    className="notification-item"
                                    onClick={this.handleClick([notification])}
                                    key={notification.id + '-notification'}>
                                    {this.componentSwitch(notification)}
                                </div>)
                            }
                        </Scrollbars>
                    </li>
                    <li>
                        <div className="fake-link" onClick={this.handleClick(unread_notifications)}><FontAwesomeIcon className="text-primary" icon={faEyeSlash} fixedWidth/> Mark all as read</div>
                    </li>
                </NavDropdown>
            )
        } else {
            return ''
        }
    }
}



const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.loggedIn,
    notifications: notificationSelector(state),
    awards: awardSelector(state),
    chapters: chapterSelector(state),
    ranks: rankSelector(state),
    users: userSelector(state),
    applications: applicationSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getNotifications: () => dispatch(fetchNotifications()),
    readNotification: (id) => dispatch(updateNotificationIsRead(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/Notifications/Notifications.js